import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import RightArrow from '../../assets/icons/chevron-left.svg';
import { AuthenticatedGETRequest, AuthenticatedPOSTRequest, gotoLocation } from '../../utils';
// MODALS
import BranchesModal from './modals/branches';
import SetClassSectionModal from './modals/class_section';
import AddClassModal from './modals/classes/add_class';
import AddSubjectModal from './modals/subjects/add_subject';

const Breadcrumb = ({ createNotification, user }) => {
    const { pathname, search } = useLocation();
    // STATES
    const [branches, setBranches] = useState([]);
    const [classes, setClasses] = useState([]);
    const [applicant, setApplicant] = useState(null);
    const [student, setStudent] = useState(null);
    const [teacher, setTeacher] = useState(null);
    const [sections, setSections] = useState([]);
    // LOADING
    const [loading, setLoading] = useState(false);
    // LABELS
    const [label, setLabel] = useState(null);
    const [blueColorStatus, setBlueColorStatus] = useState(false);
    const [subLabel, setSubLabel] = useState(null);
    const [backLink, setBackLink] = useState(null);
    const [downloadPDF, setDownloadPDF] = useState(false);
    const [studentCard, setStudentCard] = useState(false);
    const [PDFID, setPDFID] = useState(null);
    const [PDFScreen, setPDFScreen] = useState(null);
    const [PDFText, setPDFText] = useState(null);
    const [registerButton, setRegisterButton] = useState(false);
    const [unRegisterButton, setUnRegisterButton] = useState(false);
    // MODALS
    const [openModal, setModal] = useState(false);
    const [addClassModal, openAddClassModal] = useState(false);
    const [addSubjectModal, openAddSubjectModal] = useState(false);
    const [addClassButton, showAddClassButton] = useState(false);
    const [addSubjectButton, showAddSubjectButton] = useState(false);
    const [selectSectionButton, setSelectSectionButton] = useState(false);
    const [selectSectionModal, setSelectSectionModal] = useState(false);

    const isTestingUser = (username) => {
        const response = /test/.test(username);
        return response;
    };

    const [testUser, setTestUser] = useState(true);

    // FUNCTIONS
    const unRegisterStudent = async () => {
        setLoading(true);
        try {
            const { success } = await AuthenticatedPOSTRequest(
                `students/${student.id}/move_student_back_to_applicants`,
            );
            if (success) {
                gotoLocation('dashboard/students');
            } else {
                setLoading(false);
                createNotification('error-toast', 'مہرنانی، کچھ غلط ہو گیا ہے۔ دوبارہ کوشش کریں۔');
            }
        } catch (error) {
            createNotification('error-toast', error);
        }
    };

    // USE EFFECT
    useEffect(() => {
        const fetchData = async (endpoint) => {
            try {
                const { data } = await AuthenticatedGETRequest(endpoint);
                return data;
            } catch (error) {
                createNotification('error-toast', 'مہرنانی، کچھ غلط ہو گیا ہے۔ دوبارہ کوشش کریں۔');
            }
        };
        if (pathname === '/dashboard/applicants') {
            setLabel('درخواست دہندگان');
            setBlueColorStatus(false);
            setDownloadPDF(false);
            setStudentCard(false);
        } else if (pathname === '/dashboard/applicants/detail' && search) {
            setBlueColorStatus(true);
            setLabel('درخواست دہندگان');
            setBackLink('dashboard/applicants');
            setPDFScreen('applicants');
            fetchData(`applicants/${search.split('=')[1]}`).then((data) => setApplicant(data));
        } else if (pathname === '/dashboard/students') {
            setLabel('طلبہ');
            setBlueColorStatus(false);
            setDownloadPDF(false);
            setStudentCard(false);
        } else if (pathname === '/dashboard/students/detail' && search) {
            setBlueColorStatus(true);
            setLabel('طلبہ');
            setBackLink('dashboard/students');
            setPDFScreen('students');
            fetchData(`students/${search.split('=')[1]}`).then((data) => setStudent(data));
            fetchData(`class_rooms`).then((data) => setClasses(data));
        } else if (pathname === '/dashboard/attendance') {
            setLabel('حاضری');
            setBlueColorStatus(false);
            setDownloadPDF(false);
            setStudentCard(false);
        } else if (pathname === '/dashboard/teachers') {
            setLabel('اساتذہ');
            setBlueColorStatus(false);
            setDownloadPDF(false);
            setStudentCard(false);
        } else if (pathname === '/dashboard/teachers/detail' && search) {
            setBlueColorStatus(true);
            setLabel('اساتذہ');
            setBackLink('dashboard/teachers');
            fetchData(`teachers/${search.split('=')[1]}`).then((data) => setTeacher(data));
        } else if (pathname === '/dashboard/classes') {
            setLabel('کلاسز');
            setBlueColorStatus(false);
            setDownloadPDF(false);
            setStudentCard(false);
            showAddClassButton(true);
        } else if (pathname === '/dashboard/subjects') {
            setLabel('مضامین');
            setBlueColorStatus(false);
            setDownloadPDF(false);
            setStudentCard(false);
            showAddSubjectButton(true);
            fetchData('class_rooms').then((data) => setClasses(data));
        }
        fetchData('branches').then((data) => setBranches(data));
        // eslint-disable-next-line
    }, [pathname, search]);

    useEffect(() => {
        if (applicant) {
            setRegisterButton(true);
            setSubLabel(applicant.name);
            setPDFID(applicant.id);
            setDownloadPDF(true);
            setPDFText('پرنٹ درخواست');
        } else {
            setRegisterButton(false);
            setDownloadPDF(false);
        }
    }, [applicant]);

    useEffect(() => {
        if (student && student.branch) {
            setSubLabel(student.name);
            setUnRegisterButton(true);
            setPDFID(student.id);
            setDownloadPDF(true);
            setStudentCard(true);
            setPDFText('پرنٹ ریکارڈ');
            if (student.section_id === null) {
                setSelectSectionButton(true);
            } else {
                setSelectSectionButton(false);
            }
        } else {
            setUnRegisterButton(false);
            setDownloadPDF(false);
            setStudentCard(false);
        }
    }, [student]);

    useEffect(() => {
        if (teacher) {
            setSubLabel(teacher.name);
        }
    }, [teacher]);

    useEffect(() => {
        if (selectSectionButton && student && classes && classes.length > 0) {
            let sections = classes.find((e) => e.id === student.class_room.id)['sections'];
            setSections(sections);
        }
    }, [classes, student, selectSectionButton]);

    useEffect(() => {
        if (user) setTestUser(isTestingUser(user.username) ? true : false);
        // eslint-disable-next-line
    }, []);

    return (
        <div className='flex justifyBetween alignCenter breadcrumb'>
            <div className='flex justifyStart alignCenter'>
                {blueColorStatus ? (
                    <h2
                        id='label'
                        style={{ fontWeight: 700, color: '#2196f3', cursor: 'pointer' }}
                        onMouseEnter={() =>
                            (document.getElementById('label').style.textDecoration = 'underline')
                        }
                        onMouseLeave={() =>
                            (document.getElementById('label').style.textDecoration = 'none')
                        }
                        onClick={() => gotoLocation(backLink)}
                    >
                        {label}
                    </h2>
                ) : (
                    <h2 style={{ fontWeight: 700, color: '#000000' }}>{label}</h2>
                )}

                {blueColorStatus && (
                    <img
                        src={RightArrow}
                        alt='right_arrow'
                        height={24}
                        width={24}
                        style={{ margin: '0 8px' }}
                    />
                )}

                {blueColorStatus && (
                    <h2 style={{ fontWeight: 700, color: '#000000' }}>{subLabel}</h2>
                )}
            </div>

            <div className='flex alignCenter'>
                {studentCard && (
                    <div
                        className='flex justifyEnd alignCenter print_button'
                        onClick={() => gotoLocation(`record/student-card?id=${PDFID}`)}
                    >
                        {`طالب علم کا کارڈ پرنٹ کریں`}
                    </div>
                )}
                {downloadPDF && (
                    <div
                        className='flex justifyEnd alignCenter print_button'
                        style={{ margin: '0 8px' }}
                        onClick={() => gotoLocation(`record/pdf?id=${PDFID}&screen=${PDFScreen}`)}
                    >
                        {PDFText}
                    </div>
                )}

                {selectSectionButton && (
                    <div
                        className='flex justifyEnd alignCenter register_button'
                        onClick={() => setSelectSectionModal(true)}
                    >
                        کلاس سیکشن منتخب کریں
                    </div>
                )}

                {registerButton && !testUser && (
                    <div
                        className='flex justifyEnd alignCenter register_button'
                        style={{ margin: '0 8px' }}
                        onClick={() => setModal(true)}
                    >
                        رجسٹر کریں
                    </div>
                )}

                {unRegisterButton && (
                    <div
                        className='flex justifyEnd alignCenter unregister_button'
                        style={{ margin: '0 8px' }}
                        onClick={() => unRegisterStudent(student.id)}
                    >
                        {loading ? <div className='custom_loader' /> : <h4>غیر رجسٹر کریں</h4>}
                    </div>
                )}

                {addClassButton && (
                    <div
                        className='flex justifyEnd alignCenter register_button'
                        style={{ margin: '0 8px' }}
                        onClick={() => openAddClassModal(true)}
                    >
                        کلاسز کا ریکارڈ درج کریں
                    </div>
                )}

                {addSubjectButton && (
                    <div
                        className='flex justifyEnd alignCenter register_button'
                        style={{ margin: '0 8px' }}
                        onClick={() => openAddSubjectModal(true)}
                    >
                        مضامین کا ریکارڈ درج کریں
                    </div>
                )}
            </div>

            {/* ADD CLASS MODAL */}
            <AddClassModal
                open={addClassModal}
                onClose={() => openAddClassModal(false)}
                onError={(error) => createNotification('error-toast', error)}
            />
            {/* ADD SUBJECT MODAL */}
            {addSubjectModal && classes.length > 0 && (
                <AddSubjectModal
                    classes={classes}
                    open={addSubjectModal}
                    onClose={() => openAddSubjectModal(false)}
                    onError={(error) => createNotification('error-toast', error)}
                />
            )}
            {/* SET CLASS AND SECTION MODAL */}
            {selectSectionModal && sections.length > 0 && (
                <SetClassSectionModal
                    id={student.id}
                    sections={sections}
                    open={selectSectionModal}
                    onClose={() => setSelectSectionModal(false)}
                    onError={(error) => createNotification('error-toast', error)}
                />
            )}
            {branches.length > 0 && applicant && (
                <BranchesModal
                    id={applicant.id}
                    open={openModal}
                    onClose={() => setModal(false)}
                    list={branches}
                    onError={(error) => createNotification('error-toast', error)}
                />
            )}
        </div>
    );
};

export default Breadcrumb;
